import { Component, OnInit } from "@angular/core";
import { ConsultarPreguntasService } from "../administrador-preguntas/consultar-preguntas.service";
import { ConflictosService } from "../administrador-conflictos/servicios/conflictos.service";
import { MatTableDataSource, MatPaginator } from "@angular/material";
import { Globals } from "src/app/globals";
import Swal from "sweetalert2";
import { Router } from "@angular/router";

@Component({
  selector: 'app-ok-front-preguntas',
  templateUrl: './ok-front-preguntas.component.html',
  styleUrls: ['./ok-front-preguntas.component.css']
})
export class OkFrontPreguntasComponent implements OnInit {
  constructor(
    private ConsultarPreguntas: ConsultarPreguntasService,
    public global: Globals,
    private conflictosService: ConflictosService,
    private router: Router,
  ) {}

   


  BotonEditarPregunta = true;
  BotonInformacion = false;
  LabelParaRegistrar = false;
  BotonCrearNuevoConflicto = false;
  BotonAnterior = false;
  BotonSiguiente = false;
  BotonFinalizar = false;
  
  

  PreguntaTipo1 = false;
  PreguntaTipo2 = false;
  VisibleBotones = false;
  PreguntaTipo3 = false;
  
  PreguntaTipo4 = false;

  Checkboxterminos1 = true;
  Checkboxterminos2 = false;
  
  
  
  tipoPregunta;
  BotonPermaneceConCambiosTexto;
  BotonEditarTexto;
  BotonConflictopermaneceigualTexto;
  BotonConflictoyanoexisteTexto;
  BotonEditarPreguntaTexto;
  BotonCrearNuevoConflictoTexto;
  BotonAnteriorTexto;
  BotonSiguienteTexto;
  BotonFinalizarTexto;
  BotonFinalizarEncuestaTexto;
  TextoParaRegistrar;
  BotonInformacionTexto;
  AnnioActual;
  funcionariosok = null;
  respuestaSeleccionada;
  //#endregion "Variables Globales"

  //#region "Funciones Generales"
  ngOnInit() {
    
    
    
    
    
    this.AnnioActual = new Date().getFullYear();
    this.ConsultarTodasLasPreguntas(this.global.PreguntaActual);
    
  }

  
  public ConsultarTodasLasPreguntas(NumeroOrdenConflicto) {
    
    
    switch(NumeroOrdenConflicto) { 
      case "20": { 
        
        this.Checkboxterminos1 = false;
        this.Checkboxterminos2 = true;
        
               
         break; 
      } 
      
      default: { 
        this.Checkboxterminos1 = true;
        this.Checkboxterminos2 = false;
         break; 
      } 
   }
    
    
    
    this.ConsultarPreguntas.ConsultarTodasLasPreguntas(
      NumeroOrdenConflicto
    ).subscribe(ArrayResultados => {
      ArrayResultados;

      //this.global.lenguaje = "es";


      let tipoconflicto = ArrayResultados[0].TipoPregunta;      
      this.global.idconflictoActual = ArrayResultados[0].idtbl_conflicto;      
      
      switch(tipoconflicto) { 
        case 1: { 
          
         
          this.BotonEditarPregunta = true;
          this.BotonInformacion = false;
          this.LabelParaRegistrar = false;
          this.BotonCrearNuevoConflicto = false;
          this.BotonAnterior = false;
          this.BotonSiguiente = true;
          
        
        
          this.PreguntaTipo1 = true;
          this.PreguntaTipo2 = false;
          this.VisibleBotones = false;
          this.PreguntaTipo3 = false;
          this.PreguntaTipo4 = false;
  
           break; 
        } 
        case 2: { 
          this.BotonEditarPregunta = true;
          this.BotonInformacion = true;
          this.LabelParaRegistrar = false;
          this.BotonCrearNuevoConflicto = false;
          this.BotonAnterior = true;
          this.BotonSiguiente = true;
          
        
        
          this.PreguntaTipo1 = false;
          this.PreguntaTipo2 = true;
          this.VisibleBotones = true;
          this.PreguntaTipo3 = false;
          this.PreguntaTipo4 = false;
           break; 
        } 
        case 3: { 
          this.BotonEditarPregunta = true;
          this.BotonInformacion = true;
          this.LabelParaRegistrar = false;
          this.BotonCrearNuevoConflicto = false;
          this.BotonAnterior = true;
          this.BotonSiguiente = true;
          
        
        
          this.PreguntaTipo1 = false;
          this.PreguntaTipo2 = false;
          this.VisibleBotones = false;
          this.PreguntaTipo3 = true;
          this.PreguntaTipo4 = false;
           break; 
        } 
        case 4: { 
          this.BotonEditarPregunta = true;
          this.BotonInformacion = true;
          this.LabelParaRegistrar = false;
          this.BotonCrearNuevoConflicto = false;
          this.BotonAnterior = true;
          this.BotonSiguiente = true;
          
        
        
          this.PreguntaTipo1 = false;
          this.PreguntaTipo2 = false;
          this.VisibleBotones = false;
          this.PreguntaTipo3 = false;
          this.PreguntaTipo4 = true;
           break; 
        } 
        default: { 
           //statements; 
           break; 
        } 
     } 

     //////conole.log(this.global.PreguntaActual);

     switch(this.global.PreguntaActual) { 
      
      

      case "20": {        
        
        this.BotonFinalizar = true;
        this.BotonSiguiente = false;
        
         break; 
      }                            
      default: { 
        this.BotonFinalizar = false;
         break; 
      } 
   }

    


      if (
        this.global.lenguaje == "es" ||
        this.global.lenguaje == "ESPANOL" ||
        this.global.lenguaje == "ESPAÑOL"
      ) {
        

        this.TituloPregunta1 = ArrayResultados[0].tipo_conflicto_espanol;
        this.TituloParrafo1_1 = ArrayResultados[0].nombre;
        this.TituloParrafo1_2 = ArrayResultados[0].DescripcionPregunta;
        this.TituloParrafo1_3 = ArrayResultados[0].Texto1ES;
        this.TituloParrafo1_4 = ArrayResultados[0].Texto2ES;
        this.TituloParrafo1_5 = ArrayResultados[0].Texto3ES;
        this.TituloParrafo1_6 = ArrayResultados[0].Texto4ES;
        this.TituloParrafo1_7 = ArrayResultados[0].Texto5ES;  
        

        this.BotonEditarTexto = "Editar Conflicto";
        this.BotonPermaneceConCambiosTexto =
          "Conflicto permanece pero con cambios";
        this.BotonConflictopermaneceigualTexto = "Conflicto permanece igual";
        this.BotonConflictoyanoexisteTexto = "Conflicto ya no existe";

        this.BotonEditarPreguntaTexto = "Editar Pregunta";
        this.BotonInformacionTexto = "Instructivo";
        this.BotonCrearNuevoConflictoTexto = "Crear Nuevo Conflicto";
        this.BotonAnteriorTexto = "Anterior Pregunta";
        this.BotonSiguienteTexto = "Siguiente Pregunta";
        this.BotonFinalizarTexto = "FINALIZAR ENCUESTA";

        this.BotonFinalizarEncuestaTexto = "Finalizar Encuesta";

        this.TextoParaRegistrar =
          "Para registrar un nuevo conflicto del presente año realiza clic en el siguiente botón:";
      } else {
        
        this.TituloPregunta1 = ArrayResultados[0].tipo_conflicto_ingles;
        this.TituloParrafo1_1 = ArrayResultados[0].ingles;
        this.TituloParrafo1_2 = ArrayResultados[0].InglesDescripcionPregunta;
        this.TituloParrafo1_3 = ArrayResultados[0].Texto1EN;
        this.TituloParrafo1_4 = ArrayResultados[0].Texto2EN;
        this.TituloParrafo1_5 = ArrayResultados[0].Texto3EN;
        this.TituloParrafo1_6 = ArrayResultados[0].Texto4EN;
        this.TituloParrafo1_7 = ArrayResultados[0].Texto5EN;

        this.BotonEditarTexto = "Edit Conflict";
        this.BotonPermaneceConCambiosTexto = "Stay With Changes";
        this.BotonConflictopermaneceigualTexto = "Conflict remains the same";
        this.BotonConflictoyanoexisteTexto = "Conflict no longer exists";

        this.BotonEditarPreguntaTexto = "Edit Question";
        this.BotonInformacionTexto = "Guideline";
        this.BotonCrearNuevoConflictoTexto = "Create New Conflict";
        this.BotonAnteriorTexto = "Previous Question";
        this.BotonSiguienteTexto = "Next Question";

        this.BotonFinalizarTexto = "END SURVEY";

        this.TextoParaRegistrar =
          "To register a new conflict this year, click on the following button:";
      }


    });
  }
  //#endregion "Funciones Generales"

  //#region "Variables Pregunta1"
  Arraypregunta1;
  dataSourcePregunta1 = new MatTableDataSource([]);
  displayedColumnsPregunta1: string[];
  VisiblePregunta1 = true;

  TituloPregunta1;
  TituloParrafo1_1;
  TituloParrafo1_2;
  TituloParrafo1_3;
  TituloParrafo1_4;
  TituloParrafo1_5;
  TituloParrafo1_6;
  TituloParrafo1_7;
  TituloParrafo1_8;
  TituloParrafo1_9;

  Pregunta1Campo1;
  Pregunta1Campo2;
  Pregunta1Campo3;
  Pregunta1Campo4;
  Pregunta1Campo5;
  Pregunta1Campo6;
  Pregunta1Campo7;
  Pregunta1Campo8;

  Pregunta1ID;
  Pregunta1annio;
  //#endregion "Variables Pregunta1"



  

  BotonPregunta1() {
    
    let valor = parseInt(this.global.PreguntaActual);
    valor = valor + 1;
    this.global.PreguntaActual = valor.toString();
    this.ConsultarTodasLasPreguntas(this.global.PreguntaActual);     

    
  }
 


  BotonAnteriorPregunta1() {
            

    let valor = parseInt(this.global.PreguntaActual);
    valor = valor - 1;
    this.global.PreguntaActual = valor.toString();
    this.ConsultarTodasLasPreguntas(this.global.PreguntaActual);
  }

  EditarPregunta1() {
    this.tipoPregunta = this.global.idconflictoActual;
    this.global.PrincipalAdministradorpreguntas = false;
    this.global.ActualizarPregunta = true;
  }

  Es(){ 
    this.global.lenguaje = "es";
    this.ngOnInit();
  }

  En(){    
    this.global.lenguaje = "en";
    this.ngOnInit();
  }


}

